import md from "@/utils/markdown/md"
import { htmlTableToMarkdown } from './TableProcessor'
export const mdRenderData = (htmlString) => {
    if (!htmlString) return
    let markdown = htmlTableToMarkdown(htmlString)
    markdown = handleSvg(markdown)
    markdown = hanldeLatex(markdown)
    return md.render(markdown)
}

function hanldeLatex(markdown) {
    // 1. 保护所有块级公式 $$...$$，避免内部被后续操作污染
    const blocks = [];
    markdown = markdown.replace(/\$\$(.*?)\$\$/gs, (match) => {
        blocks.push(match);
        return `__BLOCK_LATEX_${blocks.length - 1}__`;
    });

    // 2. 保护转义序列：\\[  \\(  \\]  \\)
    //    正则说明：\\\\ 匹配两个反斜杠，后面跟 [ ( ] ) 
    const escapes = [];
    markdown = markdown.replace(/\\\\\[|\\\\\(|\\\\\]|\\\\\)/g, (match) => {
        escapes.push(match);
        return `__ESCAPE_${escapes.length - 1}__`;
    });

    // 3. 处理未被转义的定界符
    markdown = markdown.replace(/\\\[/g, "\n\r$$")
                       .replace(/\\\]/g, "$$\n\r")
                       .replace(/\\\(/g, "$")
                       .replace(/\\\)/g, "$");

    // 4. 清理行内公式 $...$ 内部的首尾空格（保留你的原逻辑）
    markdown = markdown.replace(/\$(\s*)(.*?)(\s*)\$/gs, (_, spaceBefore, formula, spaceAfter) => {
        return "$" + formula.trim() + "$";
    });

    // 5. 确保块级公式 $$...$$ 前后有换行（方便 Markdown 解析）
    markdown = markdown.replace(/\$\$(.*?)\$\$/gs, (match) => {
        return "\n\r" + match + "\n\r";
    });

    // 6. 恢复转义序列
    markdown = markdown.replace(/__ESCAPE_(\d+)__/g, (_, idx) => escapes[parseInt(idx)]);

    // 7. 恢复块级公式
    markdown = markdown.replace(/__BLOCK_LATEX_(\d+)__/g, (_, idx) => blocks[parseInt(idx)]);

    return markdown;
}

function handleSvg(markdown) {
    // 在 svg 加 \n
    return markdown.replaceAll(/<svg/g, "<div><svg").replaceAll(/<\/svg>/g, "</svg></div>")

}
